(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[91493],{

/***/ 91493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Footer_DefaultFooter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./redux/apis/dataSending.js
var dataSending = __webpack_require__(56962);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/SubscribeForm/styles.module.scss
var styles_module = __webpack_require__(90627);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/SubscribeForm/index.jsx









var SubscribeForm = function() {
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)(""), error = ref1[0], setError = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSubscribeMutation */.iD)({
        fixedCacheKey: dataSending/* SUBSCRIPTION_CASH_KEY */.X3
    }), 2), subscribe = ref2[0], ref3 = ref2[1], isLoading = ref3.isLoading, tmp = ref3.data, subscriptionEmail = (tmp === void 0 ? {} : tmp).subscriptionEmail;
    var pathname = (0,router.useRouter)().pathname;
    var handleChange = function(event) {
        var value = event.target.value;
        setEmail(value);
        if ((value === null || value === void 0 ? void 0 : value.length) && !(0,helper/* validateEmail */.oH)(value)) {
            setError("Please enter a valid email address.");
        } else {
            setError("");
        }
    };
    var handleSubmit = function(event) {
        event.preventDefault();
        if (isLoading) {
            return;
        }
        subscribe({
            email: email,
            pathname: pathname
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).form,
        children: subscriptionEmail ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (styles_module_default())["success-message"],
            children: "We have received your request. We will back in a flash⚡."
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default())["input-wrapper"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "text",
                            value: email,
                            onChange: handleChange,
                            placeholder: "Enter your email",
                            className: classnames_default()((styles_module_default()).input, (0,_define_property/* default */.Z)({}, (styles_module_default()).invalid, error))
                        }),
                        error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (styles_module_default()).error,
                            children: error
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    onClick: handleSubmit,
                    disabled: isLoading,
                    className: (styles_module_default()).button,
                    children: "Subscribe"
                })
            ]
        })
    });
};
/* harmony default export */ var components_SubscribeForm = (SubscribeForm);

// EXTERNAL MODULE: ./UI/sections/Footer/DefaultFooter/FooterHeader/styles.module.scss
var FooterHeader_styles_module = __webpack_require__(54011);
var FooterHeader_styles_module_default = /*#__PURE__*/__webpack_require__.n(FooterHeader_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Footer/DefaultFooter/FooterHeader/index.jsx



var FooterHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FooterHeader_styles_module_default())["footer-header"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FooterHeader_styles_module_default())["text-block"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (FooterHeader_styles_module_default())["heading-text"],
                        children: "Sign up for our newsletter!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (FooterHeader_styles_module_default())["normal-text"],
                        children: "No spam, only valuable content!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SubscribeForm, {})
        ]
    });
};
/* harmony default export */ var DefaultFooter_FooterHeader = (FooterHeader);

// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
;// CONCATENATED MODULE: ./UI/components/ClutchWidget/index.jsx


var ClutchWidget = function() {
    var ref = (0,react.useState)(false), isScriptLoaded = ref[0], setIsScriptLoaded = ref[1];
    (0,react.useEffect)(function() {
        var script = document.createElement("script");
        script.src = "https://widget.clutch.co/static/js/widget.js";
        script.async = true;
        script.onload = function() {
            setIsScriptLoaded(true);
        };
        document.body.appendChild(script);
        return function() {
            document.body.removeChild(script);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (isScriptLoaded) {
            if (window.CLUTCHCO) {
                window.CLUTCHCO.Init();
            }
        }
    }, [
        isScriptLoaded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "clutch-widget",
        "data-url": "https://widget.clutch.co",
        "data-widget-type": "1",
        "data-height": "40",
        "data-nofollow": "true",
        "data-expandifr": "true",
        "data-darkbg": "darkbg",
        "data-clutchcompany-id": "381822"
    });
};
/* harmony default export */ var components_ClutchWidget = (ClutchWidget);

// EXTERNAL MODULE: ./UI/sections/Footer/DefaultFooter/FooterBody/styles.module.scss
var FooterBody_styles_module = __webpack_require__(60547);
var FooterBody_styles_module_default = /*#__PURE__*/__webpack_require__.n(FooterBody_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Footer/DefaultFooter/FooterBody/index.jsx





var FooterCenter = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FooterBody_styles_module_default())["footer-body"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FooterBody_styles_module_default())["block-1"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkWrapper/* default */.Z, {
                        path: "/",
                        className: (FooterBody_styles_module_default()).logo,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                type: "whiteLogo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                type: "whiteYellowText"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (FooterBody_styles_module_default())["white-text"],
                        children: "Software innovation powerhouse born to take your business to the top!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ClutchWidget, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FooterBody_styles_module_default())["block-2"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (FooterBody_styles_module_default())["grey-text"],
                                children: "Let’s Talk"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (FooterBody_styles_module_default())["block-2__content"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                        path: "mailto:hi@yellow.systems",
                                        className: (FooterBody_styles_module_default())["large-text"],
                                        target: "_blank",
                                        children: "hi@yellow.systems"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (FooterBody_styles_module_default())["large-text"],
                                        children: "+1 (940) 601 6017"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (FooterBody_styles_module_default())["contact-links"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                                className: (FooterBody_styles_module_default())["link-text"],
                                                path: "https://calendly.com/yellow-systems-crew/30min",
                                                target: "_blank",
                                                children: "Book a call"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                                className: (FooterBody_styles_module_default())["link-text"],
                                                path: "http://wa.me/19406016017",
                                                target: "_blank",
                                                children: "Chat with us"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (FooterBody_styles_module_default())["grey-text"],
                                children: "Address"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (FooterBody_styles_module_default())["large-text"],
                                children: "\uD83C\uDDFA\uD83C\uDDF8 44 Tehama St, San Francisco, CA 94105, United States"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FooterBody = (FooterCenter);

// EXTERNAL MODULE: ./utils/constants/contacts.js
var contacts = __webpack_require__(32522);
// EXTERNAL MODULE: ./UI/sections/Footer/DefaultFooter/FooterFoot/styles.module.scss
var FooterFoot_styles_module = __webpack_require__(61054);
var FooterFoot_styles_module_default = /*#__PURE__*/__webpack_require__.n(FooterFoot_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Footer/DefaultFooter/FooterFoot/index.jsx






var FooterFoot = function() {
    var pathname = (0,router.useRouter)().pathname;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FooterFoot_styles_module_default())["footer-foot"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FooterFoot_styles_module_default())["social-links"],
                children: Object.values(contacts/* SOCIAL_MEDIA */.CL).map(function(param) {
                    var icon = param.iconLight, title = param.title, link = param.link;
                    return link && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                        className: (FooterFoot_styles_module_default())["social-link"],
                        path: link,
                        googleAnalyticProps: {
                            action: "Click",
                            category: "Social",
                            label: pathname,
                            data: title
                        },
                        isSocialLink: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                            type: icon,
                            className: (FooterFoot_styles_module_default()).icon
                        })
                    }, "networks/".concat(link));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FooterFoot_styles_module_default()).bottom,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\xa9 All right reserved. Yellow 2025"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FooterFoot_styles_module_default())["privacy-policy"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                path: "/privacy-policy",
                                className: (FooterFoot_styles_module_default()).link,
                                children: "Privacy Policy"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                path: "/terms-and-conditions",
                                className: (FooterFoot_styles_module_default()).link,
                                children: "Terms & Privacy"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var DefaultFooter_FooterFoot = (FooterFoot);

// EXTERNAL MODULE: ./UI/sections/Footer/DefaultFooter/CircleButton/styles.module.scss
var CircleButton_styles_module = __webpack_require__(9474);
var CircleButton_styles_module_default = /*#__PURE__*/__webpack_require__.n(CircleButton_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Footer/DefaultFooter/CircleButton/index.jsx



var CircleButton = function() {
    var onClick = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: (CircleButton_styles_module_default()).button,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
            type: "arrowNarrowUp"
        })
    });
};
/* harmony default export */ var DefaultFooter_CircleButton = (CircleButton);

// EXTERNAL MODULE: ./UI/sections/Footer/DefaultFooter/styles.module.scss
var DefaultFooter_styles_module = __webpack_require__(66821);
var DefaultFooter_styles_module_default = /*#__PURE__*/__webpack_require__.n(DefaultFooter_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Footer/DefaultFooter/index.jsx






var DefaultFooter = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (DefaultFooter_styles_module_default()).footerContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultFooter_CircleButton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultFooter_FooterHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterBody, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultFooter_FooterFoot, {})
        ]
    });
};
/* harmony default export */ var Footer_DefaultFooter = (DefaultFooter);


/***/ }),

/***/ 32522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ SOCIAL_MEDIA; },
/* harmony export */   "UE": function() { return /* binding */ PHONE_NUMBER; },
/* harmony export */   "Vr": function() { return /* binding */ EMAIL_LINK; },
/* harmony export */   "o4": function() { return /* binding */ ADDRESS; },
/* harmony export */   "zm": function() { return /* binding */ PLACEMENT_DATA; }
/* harmony export */ });

var EMAIL_LINK = "hi@yellow.systems";
var SOCIAL_MEDIA = {
    linkedin: {
        id: "linkedin",
        title: "LinkedIn",
        iconDark: "linkedinFilled",
        iconLight: "linkedinWhite",
        link: "https://www.linkedin.com/company/yellow-systems"
    },
    facebook: {
        id: "facebook",
        title: "Facebook",
        iconDark: "facebookDark",
        iconLight: "facebookWhite",
        link: "https://www.facebook.com/yellow.systems/"
    },
    twitter: {
        id: "twitter",
        title: "Twitter",
        iconDark: "twitterFilled",
        iconLight: "twitterWhite",
        link: "https://mobile.twitter.com/yellow_systems"
    },
    dribbble: {
        id: "dribbble",
        title: "Dribbble",
        iconDark: "dribbbleFilled",
        iconLight: "dribbbleWhite",
        link: "https://dribbble.com/yellow_systems"
    },
    behance: {
        id: "behance",
        title: "Behance",
        iconDark: "behanceFilled",
        iconLight: "behanceWhite",
        link: "https://www.behance.net/yellow_systems"
    },
    youtube: {
        id: "youtube",
        title: "YouTube",
        iconDark: "youtubeSocialFilled",
        iconLight: "youtubeWhite",
        link: "https://www.youtube.com/@yellowsystems9900"
    },
    instagram: {
        id: "instagram",
        title: "Instagram",
        iconDark: "instagramFilled",
        iconLight: "instagramWhite",
        link: "https://www.instagram.com/yellow.systems/"
    }
};
var PHONE_NUMBER = {
    us: "+1 (940) 601 6017"
};
var ADDRESS = {
    us: {
        addressCountry: "USA",
        addressLocality: "San Francisco",
        streetAddress: "44 Tehama St",
        postalCode: "94105"
    },
    ar: {
        addressCountry: "Argentina",
        addressLocality: "Buenos Aires",
        streetAddress: "Av. Corrientes 1312",
        postalCode: "C1043ABN"
    },
    pl: {
        addressCountry: "Poland",
        addressLocality: "Warszawa",
        streetAddress: "Grzybowska 62",
        postalCode: "00-855"
    },
    cy: {
        addressCountry: "Cyprus",
        addressLocality: "Larnaca",
        streetAddress: "Agias Faneromenis, 143, Flat 201",
        postalCode: "6031"
    }
};
var PLACEMENT_DATA = {
    USA: [
        "".concat(ADDRESS.us.streetAddress, " ").concat(ADDRESS.us.addressLocality, " ").concat(ADDRESS.us.postalCode), 
    ],
    Poland: [
        "".concat(ADDRESS.pl.addressLocality, " ").concat(ADDRESS.pl.postalCode),
        ADDRESS.pl.streetAddress, 
    ],
    Argentina: [
        "".concat(ADDRESS.ar.streetAddress, " ").concat(ADDRESS.ar.postalCode),
        ADDRESS.ar.addressLocality, 
    ]
};


/***/ }),

/***/ 90627:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__W31QA","input-wrapper":"styles_input-wrapper__tVSXY","input":"styles_input__YqKir","success-message":"styles_success-message__ZU9__","error":"styles_error__4vNDf","fadeIn":"styles_fadeIn__i415X","invalid":"styles_invalid__H0nKz","button":"styles_button__4JKQY"};

/***/ }),

/***/ 9474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__EOCWR"};

/***/ }),

/***/ 60547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer-body":"styles_footer-body__v5h8Y","white-text":"styles_white-text__ndaTT","grey-text":"styles_grey-text__BqpN3","link-text":"styles_link-text___VBEc","large-text":"styles_large-text__KJUkg","contact-links":"styles_contact-links__lM5B4","block-1":"styles_block-1__QUFKt","logo":"styles_logo__mVl_t","clutch-review":"styles_clutch-review__eBigy","block-2":"styles_block-2__Cleh4","block-2__content":"styles_block-2__content__CysoQ"};

/***/ }),

/***/ 61054:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer-foot":"styles_footer-foot__I7mol","social-links":"styles_social-links__FR253","social-link":"styles_social-link__4Eal9","bottom":"styles_bottom__VKZNA","privacy-policy":"styles_privacy-policy__XTf7m","link":"styles_link__hXUH0"};

/***/ }),

/***/ 54011:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer-header":"styles_footer-header__3_jM5","text-block":"styles_text-block__7Sfcd","heading-text":"styles_heading-text__YkhmI","normal-text":"styles_normal-text__Rg_J2"};

/***/ }),

/***/ 66821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"styles_footerContainer__fOuRv"};

/***/ })

}]);